export function SimpleTextParagraph(props: { txt: string }) {
  return <p className='text-justify text-[16px] font-normal leading-[24px] text-[#4A4A4A]'>{props.txt}</p>
}
